export default __webpack_public_path__ + "static/study-list-9e090e1232df20f10ccf614e3e921eaa.gif";